import React, { useState, useEffect } from "react";
import "../css/Profile.css";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

export default function Profile() {
  const picLink = "https://cdn-icons-png.flaticon.com/128/1177/1177568.png";
  const navigate = useNavigate();

  const [user, setUser] = useState({});
  const [isEditing, setIsEditing] = useState(false);
  const [newName, setNewName] = useState("");
  const [newAbout, setNewAbout] = useState("");
  const [newAboutCount, setNewAboutCount] = useState(0);
  const [ukey, setUkey] = useState("");
  const [showAboutModal, setShowAboutModal] = useState(false);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (!storedUser) {
      navigate("/signin");
      return;
    }
    const parsed = JSON.parse(storedUser);
    if (!parsed || !parsed._id) {
      navigate("/signin");
      return;
    }

    fetch(`/user/${parsed._id}`, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("jwt"),
      },
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.user) {
          setUser(result.user);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }, [navigate]);

  const startEditing = () => {
    setNewName(user.name || "");
    setNewAbout(user.about || "");
    setNewAboutCount((user.about || "").length);
    setUkey("");
    setIsEditing(true);
  };

  const cancelEditing = () => {
    setUkey("");
    setIsEditing(false);
  };

  const saveProfile = () => {
    const cleanUKey = ukey.trim().toLowerCase();
    if (!cleanUKey) {
      toast.error("Please enter your UKey to update profile");
      return;
    }
    if (!newName.trim()) {
      toast.error("Name cannot be empty");
      return;
    }
    if (newName.length > 100) {
      toast.error("Name cannot exceed 100 characters");
      return;
    }
    if (!newAbout.trim()) {
      toast.error("About cannot be empty");
      return;
    }
    if (newAbout.length > 1000) {
      toast.error("About cannot exceed 1000 characters");
      return;
    }

    fetch(`/user/${user._id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("jwt"),
      },
      body: JSON.stringify({
        name: newName.trim(),
        about: newAbout.trim(),
        ukey: cleanUKey,
      }),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.error) {
          toast.error(result.error);
        } else {
          setUser(result.user);
          try {
            const current = JSON.parse(localStorage.getItem("user") || "{}");
            localStorage.setItem("user", JSON.stringify({ ...current, ...result.user }));
          } catch (e) {}
          setUkey("");
          setIsEditing(false);
          toast.success("Profile updated successfully");
        }
      })
      .catch((err) => {
        toast.error("Something went wrong");
        console.error(err);
      });
  };

  return (
    <div className="profile">
      <div className="profile-frame">
        <div className="profile-pic">
          <img
            src={(user?.Photo && !user.Photo.includes('cloudinary')) ? user.Photo : picLink}
            alt="Profile Avatar"
          />
        </div>

        <div className="profile-data">
          <div className="profile-header">
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <h1 style={{ marginTop: "7px" }} className="username">{user.name}</h1>
            </div>
          </div>

          {/* Options button */}
          <button
            id="options_btn"
            className="profile-page-options"
            onClick={() => navigate('/profile/options')}
            aria-label="Profile options"
          >
            <span style={{ marginRight: "-14px", marginTop: "-15px" }} className="material-symbols-outlined">menu</span>
          </button>

          {isEditing ? (
            <div style={{ marginTop: 12 }}>
              <label style={{ display: 'block', marginBottom: 6, fontWeight: 600 }}>UKey (Update Secret Key)</label>
              <input
                className="mainInputs"
                type="text"
                placeholder="Enter UKey to edit profile"
                value={ukey}
                onChange={(e) => setUkey(e.target.value.toLowerCase().replace(/\s+/g, ''))}
                maxLength={100}
                style={{ width: '100%', marginBottom: 12 }}
              />

              <label style={{ display: 'block', marginBottom: 6, fontWeight: 600 }}>Name</label>
              <input
                className="mainInputs"
                type="text"
                value={newName}
                onChange={(e) => setNewName(e.target.value)}
                maxLength={100}
                style={{ width: '100%', marginBottom: 12 }}
              />

              <label style={{ display: 'block', marginBottom: 6, fontWeight: 600 }}>About</label>
              <textarea
                className="mainInputs"
                placeholder="Tell people about yourself..."
                value={newAbout}
                onChange={(e) => {
                  setNewAbout(e.target.value);
                  setNewAboutCount(e.target.value.length);
                }}
                maxLength={1000}
                style={{ minHeight: 160, width: '100%' }}
              />
              <div style={{ textAlign: 'right', fontSize: 12, color: '#666' }}>{newAboutCount}/1000</div>

              <div style={{ marginTop: 14 }}>
                <button
                  style={{
                    marginRight: "10px",
                    borderRadius: "10px",
                    backgroundColor: "#9e9ee5",
                    fontWeight: "600",
                    color: "black",
                    fontSize: "15px",
                    padding: "8px 16px",
                    border: "none",
                    cursor: "pointer"
                  }}
                  onClick={saveProfile}
                >
                  Save
                </button>
                <button
                  onClick={cancelEditing}
                  style={{
                    borderRadius: "10px",
                    backgroundColor: "#67a767",
                    fontWeight: "600",
                    color: "black",
                    fontSize: "15px",
                    padding: "8px 16px",
                    border: "none",
                    cursor: "pointer"
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          ) : (
            <div style={{ marginTop: 8 }}>
              {user.phone && (
                <p style={{ margin: "6px 0" }}>
                  <strong style={{ color: "#94a3b8" }}>Phone: </strong>
                  <span style={{ color: "#fff" }}>{user.phone}</span>
                </p>
              )}

              {user?.about && (
                <div style={{ marginTop: 12 }}>
                  <button
                    onClick={() => setShowAboutModal(true)}
                    style={{
                      marginBottom: "10px",
                      padding: '8px 16px',
                      borderRadius: "12px",
                      backgroundColor: "#494949",
                      color: "white",
                      fontWeight: "bolder",
                      border: "none",
                      cursor: "pointer"
                    }}
                  >
                    See About
                  </button>
                </div>
              )}

              <div style={{ marginTop: 8 }}>
                <button
                  style={{
                    borderRadius: "12px",
                    backgroundColor: "#494949",
                    color: "white",
                    fontWeight: "bolder",
                    padding: "8px 16px",
                    border: "none",
                    cursor: "pointer"
                  }}
                  onClick={startEditing}
                >
                  Edit About
                </button>
              </div>
            </div>
          )}

          {showAboutModal && (
            <div
              style={{
                position: 'fixed',
                left: 0,
                top: 0,
                right: 0,
                bottom: 0,
                background: 'rgba(0,0,0,0.6)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 2000
              }}
              onClick={() => setShowAboutModal(false)}
            >
              <div
                onClick={(e) => e.stopPropagation()}
                style={{
                  background: 'var(--surface, #1e293b)',
                  color: 'var(--text, #fff)',
                  padding: 24,
                  borderRadius: 12,
                  maxWidth: '540px',
                  width: '90%',
                  maxHeight: '80%',
                  overflowY: 'auto'
                }}
              >
                <h3 style={{ marginTop: 0 }}>About</h3>
                <div style={{ whiteSpace: 'pre-wrap', lineHeight: 1.6, marginTop: 12 }}>{user.about}</div>
                <div style={{ textAlign: 'right', marginTop: 16 }}>
                  <button
                    onClick={() => setShowAboutModal(false)}
                    style={{
                      padding: '8px 16px',
                      borderRadius: "12px",
                      color: '#fff',
                      backgroundColor: "#830a0a",
                      border: "none",
                      cursor: "pointer"
                    }}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
